<template>
  <div class="projectStep">
    <div
      :title="$t('updateNewSip.goTip')"
      class="step step1_active"
      @click="toCurrentStep(0)"
    >
      <span></span>
      <!-- 项目配置 -->
      <h3>{{ $t("deviceSip.projectConfig") }}</h3>
    </div>
    <div
      class="step"
      :class="stepTwoClass"
      :title="$t('updateNewSip.goTip')"
      @click="toCurrentStep(1)"
    >
      <i v-for="i in 9" :key="i"></i>
      <span></span>
      <!-- 区域配置 -->
      <h3>{{ $t("deviceSip.areaConfig") }}</h3>
    </div>
    <div
      class="step"
      :class="stepThreeClass"
      :title="$t('updateNewSip.goTip')"
      @click="toCurrentStep(2)"
    >
      <i v-for="i in 9" :key="i"></i>
      <span></span>
      <!-- 设备配置&预览导出 -->
      <h3>
        {{ $t("deviceSip.deviceConfig") }}&{{ $t("deviceSip.exportConfig") }}
      </h3>
    </div>
  </div>
</template>
<script>
export default {
  name: "projectStep",
  components: {},
  filters: {},
  directives: {},
  mixins: {},
  props: {
    stepTwoClass: {
      type: String,
      default: "step2_no",
    },
    stepThreeClass: {
      type: String,
      default: "step3_no",
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  beforeUpdate() {},
  beforeDestroy() {},
  beforeRouteEnter(to, from, next) {
    next();
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  methods: {
    toCurrentStep(val) {
      this.$emit("setCurrentStep", val);
    },
  },
};
</script>
<style lang="scss" scoped>
.projectStep {
  width: 100%;
  height: 100%;
  margin-top: 100px;
  /* 基础 */
  .step {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    span {
      display: block;
      width: 38px;
      height: 38px;
      margin-top: 15px;
      margin-bottom: 10px;
      background-size: 100% 100%;
    }
    h3 {
      display: flex;
      margin-bottom: 10px;
      word-break: normal;
      text-align: center;
    }
    i {
      display: block;
      width: 8px;
      height: 8px;
      margin-bottom: 8px;
      border-radius: 50%;
    }
  }
  .step1_active {
    span {
      background: url("../../../assets/image/projectConfig/step1_active.png")
        no-repeat center center;
      background-size: 100% 100%;
    }
    h3 {
      color: #0f75ff;
    }
  }
  .step2_active {
    span {
      background: url("../../../assets/image/projectConfig/step2_active.png")
        no-repeat center center;
      background-size: 100% 100%;
    }
    h3 {
      color: #0f75ff;
    }
    i {
      background: #0f75ff;
    }
  }
  .step2_no {
    span {
      background: url("../../../assets/image/projectConfig/step2_no.png")
        no-repeat center center;
      background-size: 100% 100%;
    }
    h3 {
      color: #d4dffe;
    }
    i {
      background: #d4dffe;
    }
  }
  .step3_active {
    span {
      background: url("../../../assets/image/projectConfig/step3_active.png")
        no-repeat center center;
      background-size: 100% 100%;
    }
    h3 {
      color: #0f75ff;
    }
    i {
      background: #0f75ff;
    }
  }
  .step3_no {
    span {
      background: url("../../../assets/image/projectConfig/step3_no.png")
        no-repeat center center;
      background-size: 100% 100%;
    }
    h3 {
      color: #d4dffe;
    }
    i {
      background: #d4dffe;
    }
  }
}
</style>
